import React from 'react'

function Home() {
  return (
    <div> 
        <h1 style={{
            
            color: "blue",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            // width: "50%",
            padding: "10px",
            height: "calc(100vh - 53px)"
        }}>WELOCOME TO CONTACT MANAGMENT SYSTEM  </h1>
    </div>
  )
}

export default Home